<template>
  <div class='lt-fyf-loading-page'>
    <div class='lt-fyf-loading-page_text'>
      We're calculating your target
    </div>
    <div class='lt-loading-animation'>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'ui.showForeground',
      'ui.hasSceneAnimations',
    ]),
    loadingDuration () {
      const seconds = this.hasSceneAnimations ? 3 : 10;
      return seconds * 1000;
    },
  },
  created: function () {
    this.showForeground = false;
    setTimeout(() => this.finishLoading(), this.loadingDuration);
  },
  methods: {
    ...mapMutations([
      'goToNextPage',
    ]),
    finishLoading () {
      this.showForeground = true;
      this.goToNextPage();
    },
  },
};
</script>

<style lang='scss'>

.lt-fyf-loading-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.lt-fyf-loading-page_text {
  background: $loading-msg-background;
  color: $main-color;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2rem;
  padding: 0.750;
  border-radius: 3px;
  box-shadow: $loading-shadow;
  text-align: center;
}

.lt-loading-animation {
  div {
    position: relative;
    display: inline-block;
    margin: 12px 6px;
    width: 30px;
    height: 30px;
    background: $loading-msg-background;
    box-shadow: $loading-shadow;
    animation: lt-loading-animation 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    &::before {
      content: '';
      position: absolute;
      top: 6px;
      right: 6px;
      bottom: 6px;
      left: 6px;
      background: $main-color;
      border-radius: 2px;
    }
    &:nth-child(1) {
      animation-delay: -0.24s;
    }
    &:nth-child(2) {
      animation-delay: -0.12s;
    }
    &:nth-child(3) {
      animation-delay: 0;
    }
  }
}
@keyframes lt-loading-animation {
  0% {
    transform: scaleY(1.4);
  }
  50%, 100% {
    transform: scaleY(1);
  }
}



</style>
